module.exports = __webpack_public_path__ + "media/images/sales/early/icon-check-4f263953978e149855761204ca18b5ac.svg";